export default __webpack_public_path__ + "static/media/logowithd.23cc0e36.png";